module.exports = __webpack_public_path__ + "static/civic-logo-invert-animated-33b81cfe72804192a6e2e029c96e6015.svg";